import { createSelector } from 'reselect';

import { Party } from 'types/service';
import { isTableside } from 'utils/purchaseUtils';
import partiesSelector from 'selectors/service/partiesSelector';

export type PartyIdToPartyMap = Dictionary<Party>;

const createPartyIdToPartyMap = (parties: Party[]) => {
  const partyIdMap: PartyIdToPartyMap = {};
  for (const party of parties) {
    // As guests walk-in, we randomly generate a negative number as party-id.
    // And when they are converted to tableside orders party ids are not updated with
    // newly generated purchase object's id. Therefore, we must map tableside
    // parties to purchase object's id *IN ADDITION* to their party id to establish
    // useful mappings. Fix made in response to https://tock.atlassian.net/browse/TK-14857 and
    // https://tock.atlassian.net/browse/TK-12736.
    //
    // Further iteration on this comes in the fix to https://squarespace.atlassian.net/browse/TK-15381
    partyIdMap[party.id] = party;
    if (party.purchase && isTableside(party.purchase)) {
      partyIdMap[party.purchase.originalPurchaseId] = party;
    }
  }
  return partyIdMap;
};

export const partiesByIdSelector = createSelector(partiesSelector, createPartyIdToPartyMap);

export const partiesByOriginalPurchaseIdSelector = createSelector(
  partiesSelector,
  (parties: Party[]): Dictionary<Party> => {
    const partiesByOriginalPurchaseId: Dictionary<Party> = {};
    parties.forEach((party) => {
      if (party.purchase && party.purchase.originalPurchaseId) {
        partiesByOriginalPurchaseId[party.purchase.originalPurchaseId] = party;
      }
    });
    return partiesByOriginalPurchaseId;
  }
);
